module.exports = __webpack_public_path__ + "europa-5_microprint.jpg?6dd83bf18ae39f4e7b129f4120502503";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_microprint.jpg
// module id = 390
// module chunks = 0